/**
 * Para alacağı bağlamı olmayan takip türlerinde BSMV alanı gösterilmez (54, 56).
 */
export function takipteBsmvAlaniniGoster(
  takipTipiEskiNo: string | number | undefined | null
): boolean {
  if (takipTipiEskiNo === undefined || takipTipiEskiNo === null) {
    return true;
  }
  const s = String(takipTipiEskiNo);
  return s !== '54' && s !== '56';
}
